import { render } from "./ThumScreen.vue?vue&type=template&id=6cf475d3"
import script from "./ThumScreen.vue?vue&type=script&lang=js"
export * from "./ThumScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__